// extracted by mini-css-extract-plugin
export default {"connectedStudentsTooltip":"connectedStudentsTooltip__O6D_C","studentGoogleInfoContainer":"studentGoogleInfoContainer__KkSgC","studentsContainer":"studentsContainer__j9nb5"};